export default class RsvpRelationsController {
    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;

        this.rsvp = null;
        this.guestlist = null;
    }
}

RsvpRelationsController.$inject = [
    '$scope',
    '$injector'
];



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/components/rsvp-relations/controller.js